<template>
  <div class="mx-3">
    <v-dialog v-model="dialog" persistent max-width="450px">
      <v-card>
        <v-card-title class="color-theme white--text">
          <h4 class="font-weight-light pl-2">Withdrawal request</h4>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <span class="body-2">Organization</span>
                  <span class="text-required">*</span>
                  <v-select
                    v-model="organization"
                    class="text-field-border"
                    :items="[
                      'mirror.ltd',
                      'btc.ltd',
                      'eth.ltd',
                      'nvm.ltd',
                      'bbc.ltd',
                      'abc.ltd',
                      'nike.ltd',
                      'addidas.ltd',
                      'thesun.ltd',
                      'sddfdf.ltd',
                    ]"
                    placeholder="select organization"
                    required
                    solo
                    dense
                    flat
                    :rules="organizationRules"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <span class="body-2">Amount</span>
                  <span class="text-required">*</span>
                  <v-text-field
                    class="text-field-border"
                    type="number"
                    v-model="amount"
                    required
                    hide-details="auto"
                    solo
                    dense
                    flat
                    :rules="amountRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <span class="body-2">Withdraw money from</span>
                  <v-text-field
                    class="text-field-border"
                    type="text"
                    v-model="withdraw"
                    required
                    hide-details="auto"
                    clearable
                    clear-icon="mdi-close mb-2"
                    solo
                    dense
                    flat
                    readonly
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <span class="body-2">Status</span>
                  <span class="text-required">*</span>
                  <v-radio-group v-model="status" row class="my-0">
                    <v-radio label="approve" :value="approve"></v-radio>
                    <v-radio label="pending" :value="pending"></v-radio>
                    <v-radio label="unapprove" :value="unapprove"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-6 pr-8">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="font-weight-regular button mx-1 text-capitalize"
            @click="closeDialog"
            width="100"
          >
            Cancel
          </v-btn>
          <v-btn
            color="rgb(66, 154, 216)"
            class="font-weight-regular button mx-1 text-capitalize"
            dark
            width="100"
            @click="validate"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-row>
        <v-col class="mr-5">
          <h3>Withdrawal request list</h3>
        </v-col></v-row
      >
      <v-row>
        <v-col cols="2">
          <span class="subtitle-2">Search</span>
          <v-text-field
            class="text-field-border subtitle-2"
            placeholder="search organization"
            type="text"
            v-model="search_org"
            hide-details="auto"
            clearable
            clear-icon="mdi-close mb-2"
            solo
            dense
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <span class="subtitle-2">Date</span>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="search_time"
                class="text-field-border subtitle-2 pl-2"
                placeholder="search date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                clear-icon="mdi-close mb-2"
                solo
                dense
                flat
              ></v-text-field>
            </template>
            <v-date-picker v-model="search_time" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="3">
          <span class="subtitle-2 search-status mt-1">Status</span>
          <v-btn-toggle
            v-model="toggle_search_status"
            mandatory
            color="primary"
            @change="searchStatus"
          >
            <v-btn height="40" class="caption"> all </v-btn>
            <v-btn height="40" class="caption"> unapprove </v-btn>
            <v-btn height="40" class="caption"> pending </v-btn>
            <v-btn height="40" class="caption"> approve </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="5" class="mt-4 text-right">
          <v-col>
            <v-btn
              class="font-weight-regular"
              dark
              color="rgb(66, 154, 216)"
              @click="openDialog"
            >
              <v-icon left> mdi-plus </v-icon>
              Add withdrawal request
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="item_default"
        class="elevation-1"
        hide-default-footer
        :search="search_org"
        :page.sync="page"
        :items-per-page="itemPerPage"
        @page-count="pageAvg"
      >
        <template v-slot:item.organization="{ item }">
          <span>{{ item.organization }}</span>
        </template>

        <template v-slot:item.status="{ item }">
          <span>{{ item.status }}</span>
        </template>

        <template v-slot:item.amount="{ item }">
          <span>{{ item.amount }}</span>
        </template>

        <template v-slot:item.time="{ item }">
          <span>{{ item.time }}</span>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            class="ma-2 body-2 primary--text text-capitalize"
            color="white"
            @click="editDialog(item)"
            depressed
          >
            Edit
          </v-btn>
        </template>
      </v-data-table>
      <v-row>
        <v-col>
          <v-pagination v-model="page" :length="pageAvg" @input="loadData"></v-pagination>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "money",
  data() {
    return {
      valid: true,
      dialog: false,
      withdraw: "Kafiwz",
      search_org: "",
      search_time: "",
      toggle_search_status: 0,
      toggle_status: true,
      organization: "",
      organizationRules: [(v) => !!v || "Organization is required"],
      amount: 0,
      amountRules: [
        (v) => !!v || "Amount is required",
        (v) => (v && v > 0) || "Amount must more than 0",
      ],
      status: 0,
      page: 1,
      pageAvg: 0,
      itemPerPage: 5,
      item_search: [],
      item_default: [
        {
          id: 1,
          organization: "abc.ltd",
          status: "approve",
          time: "2021-01-20 10:34",
          amount: 15000,
        },
        {
          id: 2,
          organization: "nike.ltd",
          status: "pending",
          time: "2021-01-20 08:34",
          amount: 200000,
        },
        {
          id: 3,
          organization: "addidas.ltd",
          status: "unapprove",
          time: "2021-01-19 13:43",
          amount: 450000,
        },
        {
          id: 4,
          organization: "thesun.ltd",
          status: "pending",
          time: "2021-01-19 12:25",
          amount: 35000,
        },
        {
          id: 5,
          organization: "bbc.ltd",
          status: "approve",
          time: "2021-01-19 13:43",
          amount: 9000,
        },
        {
          id: 6,
          organization: "sddfdf.ltd",
          status: "pending",
          time: "2021-01-20 08:55",
          amount: 98000,
        },
      ],
      mode: "add",
      item_id: "",
    };
  },
  mounted() {
    this.calPage();
    this.item_search = this.item_default;
  },
  computed: {
    headers() {
      return [
        {
          text: "Organization",
          align: "left",
          sortable: false,
          value: "organization",
        },
        {
          text: "Status",
          sortable: false,
          value: "status",
          filterable: false,
        },
        {
          text: "Amount",
          value: "amount",
          sortable: false,
          filterable: false,
        },
        {
          text: "Create Date",
          value: "time",
          sortable: false,
          filterable: false,
        },
        {
          text: "Edit Withdraw",
          value: "action",
          sortable: false,
          filterable: false,
        },
      ];
    },
  },
  methods: {
    calPage() {
      let totalItem = this.item_default.length;
      this.pageAvg = Math.ceil(totalItem / this.itemPerPage);
      this.loadData();
    },
    loadData() {},
    closeDialog() {
      this.dialog = false;
      this.$refs.form.reset();
    },
    openDialog() {
      this.item_id = "";
      this.dialog = true;
      this.$refs.form.reset();
      this.mode = "add";
      this.withdraw = "Kafiwz";
    },
    editDialog(item) {
      this.withdraw = "Kafiwz";
      this.item_id = item.id;
      this.organization = item.organization;
      this.amount = item.amount;
      switch (item.status) {
        case "approve":
          this.status = 0;
          break;
        case "pending":
          this.status = 1;
          break;
        case "unapprove":
          this.status = 2;
          break;
      }
      this.mode = "edit";
      this.dialog = true;
    },
    validate() {
      let isValid = this.$refs.form.validate();
      if (!isValid) {
        this.dialog = true;
      } else {
        this.addData();
        this.closeDialog();
      }
    },
    addData() {
      if (this.mode == "add") {
        // add data
        let itemLength = this.item_default.length;
        this.item_default.push({
          id: itemLength++,
          organization: this.organization,
          time: "2021-01-21 15:40",
          status: "approve",
        });
      } else {
        if (this.item_id != "") {
          // edit data
          this.item_default[this.item_id - 1].organization = this.organization;
          this.item_default[this.item_id - 1].amount = this.amount;

          switch (this.status) {
            case 0:
              this.item_default[this.item_id - 1].status = "approve";
              break;
            case 1:
              this.item_default[this.item_id - 1].status = "pending";
              break;
            case 2:
              this.item_default[this.item_id - 1].status = "unaprove";
              break;

            default:
              break;
          }
        }
      }
      this.calPage();
    },
    searchStatus() {
      this.item_default = this.item_search;
      switch (this.toggle_search_status) {
        case 1:
          this.item_default = this.item_default.filter((item) => {
            return item.status === "unapprove";
          });

          break;
        case 2:
          this.item_default = this.item_default.filter((item) => {
            return item.status === "pending";
          });
          break;
        case 3:
          this.item_default = this.item_default.filter((item) => {
            return item.status === "approve";
          });
          break;
      }
      this.calPage();
    },
  },
};
</script>

<style scoped>
.color-theme {
  background-color: rgb(51, 97, 137);
}

.text-field-border {
  border: 1px solid;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}

.text-required {
  color: red;
}

.search-status {
  display: block;
}
</style>
